import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import AuthHeader from './AuthHeader';
import Login from './AuthLogin';
import CSLogin from './CSLogin';
import Signup from './AuthSignUp';
import SignupWellness from './AuthSignUp/Wellness';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Logout from './Logout';
import SoftwareApprovalContainer from '../../containers/SoftwareApprovalContainer';

import utils from '../../lib/utils';

import './index.scss';

const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
export default class Auth extends React.Component {
  componentWillMount() {
    const { auth, history } = this.props;
    const { brand_ids, studio_id, role, features } = auth;
    const user = utils.getCookie('user');
    const domain = utils.getCookie('domain');
    const pausedBusiness = utils.getCookie('subscription_status') === 'SUSPENDED';
    const isLoggedIn = utils.getCookie('tl_user_login') === 'true' || auth.isLoggedIn;
    console.log('tl_user_login', utils.getCookie('tl_user_login') === 'true');
    this.props.versionMisMatchFalse();
    // this.props.versionMisMatchTrue();
    if (!isLoggedIn && user && domain) {
      if (!pausedBusiness) {
        if (role === 'MARKETING') {
          // if(features && features.includes('LEAD_ENGAGE_ENABLED')){
          //   history.replace('/app/leadengage');
          // }else if(features && features.includes('OUTREACH_CREATE')){
          //   history.replace('/app/outreach');
          // }
          history.replace('/app/campaigns');
        } else if (window.innerWidth < 768) {
          history.replace('/app/conversation');
        } else if (brand_ids && studio_id && brand_ids.includes(studio_id)) {
          history.replace('/app/dashboard');
        } else {
          history.replace('/app/conversation');
        }
      } else {
        history.replace('/app/dashboard');
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = this.props;
    const { auth } = nextProps;
    const { brand_ids, studio_id, role, features } = auth;
    console.log('auth', auth);
    const pausedBusiness = utils.getCookie('subscription_status') === 'SUSPENDED';
    const isLoggedIn = utils.getCookie('tl_user_login') === 'true' || auth.isLoggedIn;
    console.log('tl_user_login', utils.getCookie('tl_user_login') === 'true');
    // On login, reditect to dashboard
    if (isLoggedIn && !nextProps.auth.isLoggedOut) {
      if (nextProps.auth.isRegistered === true) {
        history.replace('/app/setup/software');
      } else {
        if (!pausedBusiness) {
          if (role === 'MARKETING') {
            // if(features && features.includes('LEAD_ENGAGE_ENABLED')){
            //   history.replace('/app/leadengage');
            // }else if(features && features.includes('OUTREACH_CREATE')){
            //   history.replace('/app/outreach');
            // }
            history.replace('/app/campaigns');
          } else if (window.innerWidth < 768) {
            history.replace('/app/conversation');
          } else if (brand_ids && studio_id && brand_ids.includes(studio_id)) {
            history.replace('/app/dashboard');
          } else {
            history.replace('/app/conversation');
          }
        } else {
          history.replace('/app/dashboard');
        }
      }
    }

    // On Logout, redirect to login
    if (
      nextProps.auth.isLoggedOut === true &&
      nextProps.auth.isLoggedIn === false &&
      !this.props.auth.isLoggedOut
    ) {
      if (csroles.includes(this.props.auth.role)) {
        history.replace('/cslogin');
      } else {
        history.replace('/login');
      }
    }
    if (
      nextProps.auth?.versionMisMatch === true &&
      !this.props.auth?.versionMisMatch && window.Config?.APP_VERSION
    ) {
      window.location.reload(true);
    }
  }

  render() {
    return (
      <div className="auth">
        <AuthHeader />
        <Route
          exact
          path="/"
          render={() => <Redirect to="/login" component={Login} />}
        />
        <Route
          exact
          path="/"
          render={() => <Redirect to="/login" component={Login} />}
        />
        <Route
          exact
          path="/csLogin"
          render={() => <Redirect to="/cslogin" component={CSLogin} />}
        />
        <Switch>
          <Route
            path="/login"
            render={(props) => <Login {...props} {...this.props} />}
          />
          <Route
            path="/cslogin"
            render={(props) => <CSLogin {...props} {...this.props} />}
          />
          <Route
            path="/signup"
            render={(props) => <Signup {...props} {...this.props} />}
          />
          <Route
            path="/signupwellness"
            render={(props) => <SignupWellness {...props} {...this.props} />}
          />
          <Route
            path="/forgot-password"
            render={(props) => <ForgotPassword {...props} {...this.props} />}
          />
          <Route
            path="/reset-password"
            render={(props) => <ResetPassword {...props} {...this.props} />}
          />
          <Route
            path="/logout"
            render={(props) => <Logout {...props} {...this.props} />}
          />
          <Route
            path="/software-approve"
            render={(props) => (
              <SoftwareApprovalContainer {...props} {...this.props} />
            )}
          />
        </Switch>
      </div>
    );
  }
}

Auth.defaultProps = {
  children: [],
  auth: {
    userid: '',
    isLoggedOut: false,
  },
};

Auth.propTypes = {
  children: PropTypes.node,
  auth: PropTypes.shape({
    userid: PropTypes.string,
    isLoggedOut: PropTypes.bool,
  }),
  router: PropTypes.shape().isRequired,
};
